import useUserInfo from "../../hooks/useUserInfo";
import {ReactNode, useState} from "react";
import {
    ButtonProps,
    OtherLoginMethodType,
    PopoverPositionType,
    PopoverTypeType,
    RecommendLoginMethodType, WalletType,
} from "../../types/types";
import {truncateAddress} from "../../utils";
import Button from "../../ui/Button";
import {LoginIcon, UnLoginIcon} from "../../assets/icon";
import LoginModal from "../LoginModal";
import UserPopover from "../UserPopover";
import {FormattedMessage, useIntl} from "react-intl";

export default function LoginButton({
                                        loginRender,
                                        methods,
                                        recommendMethods,
                                        onLoginClick,
                                        popoverPosition = "right",
                                        popoverType = "hover",
                                        popoverGap = 20,
                                        walletMethods,
                                        ...props
                                    }: Omit<ButtonProps, 'onClick' | 'highlight'> & {
    loginRender?: ReactNode
    methods?: OtherLoginMethodType[],
    recommendMethods?: RecommendLoginMethodType[]
    walletMethods?: WalletType[]
    onLoginClick?: () => void
    popoverPosition?: PopoverPositionType
    popoverType?: PopoverTypeType,
    popoverGap?: number | string
}) {
    const intl = useIntl()
    const {isLogin, username} = useUserInfo()
    const [loginOpen, setLoginOpen] = useState(false)
    if (!isLogin) {
        return <>
            <LoginModal methods={methods} walletMethods={walletMethods} recommendMethods={recommendMethods} isOpen={loginOpen}
                        onClose={() => setLoginOpen(false)}/>
            <Button className={'matchid-unlogin-btn'} {...props} highlight onClick={() => setLoginOpen(true)}>
                <UnLoginIcon/>
                <span><FormattedMessage id="login"/></span>
            </Button>
        </>
    }
    return loginRender ? <>{loginRender}</> :
        <UserPopover position={popoverPosition} type={popoverType} gap={popoverGap}>
            <Button onClick={onLoginClick} className={'matchid-login-btn'} {...props}>
                <LoginIcon/>
                <span>{username ? truncateAddress(username) : ('MatchID ' + intl.formatMessage({
                    id: 'user'
                }))}</span>
            </Button>
        </UserPopover>

}